import React from 'react';

// Minimal Markdown subset used by legal documents: "## heading", "- bullet", blank-line paragraphs,
// **bold**, *italic*, [text](url). Deliberately tiny — no HTML passthrough.
const inline = (text, keyPrefix) => {
  const out = [];
  const re = /(\*\*[^*]+\*\*|\*[^*]+\*|\[[^\]]+\]\([^)]+\))/g;
  let last = 0;
  let m;
  let i = 0;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) out.push(text.slice(last, m.index));
    const tok = m[0];
    if (tok.startsWith('**')) out.push(<strong key={`${keyPrefix}-b${i}`}>{tok.slice(2, -2)}</strong>);
    else if (tok.startsWith('[')) {
      const [, label, href] = tok.match(/\[([^\]]+)\]\(([^)]+)\)/);
      const external = /^https?:/i.test(href);
      out.push(
        <a key={`${keyPrefix}-a${i}`} href={href} className="text-[#002FA7] font-semibold hover:underline"
          target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined}
          data-testid={href.startsWith('mailto:') ? 'legal-contact-email' : undefined}>{label}</a>
      );
    } else out.push(<em key={`${keyPrefix}-i${i}`}>{tok.slice(1, -1)}</em>);
    last = m.index + tok.length;
    i += 1;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
};

export const renderLegalMarkdown = (body) => {
  const blocks = (body || '').replace(/\r\n/g, '\n').split(/\n\s*\n/);
  const nodes = [];
  blocks.forEach((raw, bi) => {
    const block = raw.trim();
    if (!block) return;
    if (block.startsWith('## ')) {
      const title = block.slice(3).trim();
      nodes.push(
        <h2 key={`h${bi}`} className="text-lg md:text-lg font-semibold text-slate-900 mt-8 mb-3 first:mt-0" style={{ fontFamily: 'Work Sans, sans-serif' }}
          data-testid={`legal-section-${title.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase()}`}>{title}</h2>
      );
      return;
    }
    const lines = block.split('\n');
    if (lines.every((l) => l.trim().startsWith('- '))) {
      nodes.push(
        <ul key={`u${bi}`} className="list-disc pl-6 space-y-1 text-sm md:text-base text-slate-700 leading-relaxed mb-3">
          {lines.map((l, li) => <li key={li}>{inline(l.trim().slice(2), `${bi}-${li}`)}</li>)}
        </ul>
      );
      return;
    }
    nodes.push(
      <p key={`p${bi}`} className="text-sm md:text-base text-slate-700 leading-relaxed mb-3" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
        {inline(lines.join(' '), `${bi}`)}
      </p>
    );
  });
  return nodes;
};

export const LegalMarkdown = ({ body }) => <div data-testid="legal-markdown">{renderLegalMarkdown(body)}</div>;

export default LegalMarkdown;
